<ng-container>
<div class="h-full flex flex-col overflow-hidden min-h-0">
    @if (creator && creator.ssCreator && creator.ssCreator.instagramAccountId && !utlra_instagram_account()) {

    <div class="flex-1 w-full flex flex-col gap-y-2 overflow-y-auto scrollbar-hide p-2 min-h-0">
        @if (instagramHandleRevealed() && creator.instaHandle && creator.instaHandle !== '') {
        <div class="flex w-full shrink-0 items-center justify-center">
            <a class="btn-basic btn-primary w-full"
                [attr.href]="'https://www.instagram.com/' + creator.instaHandle.replace('@', '')"
                target="_blank" rel="noopener noreferrer">
                &#64;{{ creator.instaHandle.replace('@', '') }}&nbsp;👉🏼
            </a>
        </div>
        }

        <!-- 2 Column Top Row -->
        @if (instagramBasics() && instagramBasics()!.profile_picture_url) {
        <div class="shrink-0 z-10 w-full grid grid-cols-2 gap-x-2 min-w-0">
            <div class="divide-y divide-gray-200 dark:divide-zinc-700 overflow-hidden card-container-pale">
                <div class="flex flex-row items-center justify-between flex-nowrap px-3 py-2">
                    <div class="flex items-center flex-row gap-x-2">
                        <div
                            class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5">
                                <path d="M12 7v14" />
                                <path
                                    d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z" />
                            </svg>
                        </div>
                        <div class="">
                            <h3 class="text-sm font-semibold text-primary">Biography</h3>
                        </div>
                    </div>
                </div>
                <div class="px-3 py-3">
                    <div class="flex items-center flex-row gap-x-4">
                        <div
                            class="relative shrink-0 size-16 rounded-full outline-1 -outline-offset-1 outline-black/5 dark:outline-white/10">
                            <atom-ldg-img inputClass="object-cover" w="full" h="full" radius="full"
                                [src]="imageService.getImageSource(instagramBasics()?.profile_picture_url, 'gallery')"></atom-ldg-img>
                        </div>

                        <div class="flex flex-col">
                            @if (instagramBasics()?.bio) {
                            <h3 class="text-sm text-primary">{{ instagramBasics()?.bio }}</h3>
                            } @else {
                            <h3 class="text-sm text-secondary italic">biography has not been set...</h3>
                            }
                            <p class="text-xs text-secondary truncate">{{
                                formatService.convertIntToString(instagramBasics()?.followers_count) }} Followers</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="divide-y divide-gray-200 dark:divide-zinc-700 overflow-hidden card-container-pale">
                <div class="flex flex-row items-center justify-between flex-nowrap px-3 py-2">
                    <div class="flex items-center flex-row gap-x-2">
                        <div
                            class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5">
                                <path d="M18 20a6 6 0 0 0-12 0" />
                                <circle cx="12" cy="10" r="4" />
                                <circle cx="12" cy="12" r="10" />
                            </svg>
                        </div>
                        <div class="">
                            @if (creator.instaHandle) {
                                @if (instagramHandleRevealed()) {
                            <h3 class="text-sm font-semibold text-primary">&#64;{{ creator.instaHandle.replace('@', '') }}</h3>
                                } @else {
                                    <h3
                                class="text-sm font-semibold font-mono tabular-nums tracking-wide text-secondary select-none"
                                aria-label="TikTok handle is hidden until your subscription is active.">
                                &#64;••••••••</h3>
                            <p class="text-xs text-secondary mt-0.5">Available with an active subscription.</p>
                                }
                            } @else {
                            <h3 class="text-sm font-semibold text-primary">Account Details</h3>
                            }
                        </div>
                    </div>
                </div>
                <div class="px-3 py-3 grid grid-cols-3 gap-2">
                    <div class="col-span-1">
                        <p class="text-xs font-light text-secondary">Followers</p>
                        <p class="text-xs text-primary">{{
                            formatService.convertIntToString(instagramBasics()?.followers_count) }}</p>
                    </div>

                    <div class="col-span-1">
                        <p class="text-xs font-light text-secondary">Posts</p>
                        @if (instagramBasics()!.media_count) {
                        <p class="text-xs text-primary">
                            {{ formatService.convertIntToString(instagramBasics()!.media_count) }}</p>
                        } @else {
                        <p class="text-xs text-primary">-</p>
                        }
                    </div>
                    @if (instagramBasics()?.apifyContentScrapingLimited) {
                        <div class="col-span-3">
                            <p class="text-xs font-light text-secondary">Limited</p>
                            <p class="text-xs text-primary">This account is limited due to Instagram's rules.</p>
                        </div>
                    } @else {
                    <div class="col-span-1">
                        <p class="text-xs font-light text-secondary">Likes</p>
                        <p class="text-xs text-primary">Coming..</p>
                    </div>
                    <div class="col-span-1">
                        <p class="text-xs font-light text-secondary">Avg. Views</p>
                        @if (creator.ssCreator && creator.ssCreator.instagramAverages &&
                        creator.ssCreator.instagramAverages.averageViews) {
                        <p class="text-xs text-primary">{{
                            formatService.convertIntToString(creator.ssCreator.instagramAverages.averageViews) || "-" }}
                        </p>
                        } @else {
                        <p class="text-xs text-primary">-</p>
                        }
                    </div>
                    <div class="col-span-1">
                        <p class="text-xs font-light text-secondary">Avg. Likes</p>
                        @if (creator.ssCreator && creator.ssCreator.instagramAverages &&
                        creator.ssCreator.instagramAverages.averageLikes) {
                        <p class="text-xs text-primary">{{
                            formatService.convertIntToString(creator.ssCreator.instagramAverages.averageLikes) || "-" }}
                        </p>
                        } @else {
                        <p class="text-xs text-primary">-</p>
                        }
                    </div>

                    <div class="col-span-1">
                        <p class="text-xs font-light text-secondary">Avg. Engagement</p>
                        @if (creator.ssCreator && creator.ssCreator.instagramAverages &&
                        creator.ssCreator.instagramAverages.averageEngagementRate) {
                        <p class="text-xs text-primary">{{
                            formatService.convertIntToString(creator.ssCreator.instagramAverages.averageEngagementRate)
                            |
                            number:'1.1-2' }}%</p>
                        } @else {
                        <p class="text-xs text-primary">-</p>
                        }
                    </div>
                    }
                </div>
            </div>
        </div>
        }
        <!-- 2 Column Top Row END -->


        <!-- Admin Row -->
        <div *appHasRole="[4,6]" class="shrink-0 z-10 w-full">
            <div class="divide-y divide-gray-200 dark:divide-zinc-700 overflow-hidden card-container-pale">
                <div class="flex flex-row items-center justify-between flex-nowrap px-3 py-2">
                    <div class="flex items-center flex-row gap-x-2">
                        <div
                            class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5">
                                <path
                                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
                                <path d="M6.376 18.91a6 6 0 0 1 11.249.003" />
                                <circle cx="12" cy="11" r="4" />
                            </svg>
                        </div>
                        <div class="">
                            <h3 class="text-sm font-semibold text-primary">Instagram Admin</h3>
                        </div>
                    </div>
                </div>
                <div class="px-3 py-3 grid grid-cols-5 gap-2">
                    <div class="col-span-1">
                        <p class="text-xs font-light text-secondary">Source</p>
                        <p class="text-xs text-primary">{{ creator.ssCreator.instagramSource }}</p>
                    </div>
                    <div class="col-span-1">
                        <p class="text-xs font-light text-secondary">Created</p>
                        <p class="text-xs text-primary">{{ instagramBasics()?.createdDate | date:'dd MMM yyyy' }}
                        </p>
                    </div>
                    <div class="col-span-1">
                        <p class="text-xs font-light text-secondary">Updated</p>
                        <p class="text-xs" [class]="getUpdatedDateColour(instagramBasics()!.updatedDate)">{{
                            formatService.getTimeSinceUpdated(instagramBasics()!.updatedDate) }}
                        </p>
                    </div>
                    <div class="col-span-1">
                        <p class="text-xs font-light text-secondary">Account ID</p>
                        <p class="text-xs text-primary">{{ instagramBasics()?.instagram_account_id }}</p>
                    </div>
                    <div class="col-span-1 flex items-center justify-end">
                        @if (refreshInstagramAccountLoading()) {
                        <span
                            class="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium text-gray-900 inset-ring inset-ring-gray-200 dark:text-white dark:inset-ring-white/10">
                            <svg aria-hidden="true"
                                class="mx-auto w-5 h-5 text-gray-200 animate-spin dark:text-gray-300 fill-primary"
                                viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                    fill="currentColor" />
                                <path
                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                    fill="currentFill" />
                            </svg>

                            Orchestrating...
                        </span>
                        } @else if (accountRefreshed()) {
                        <span
                            class="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 inset-ring inset-ring-green-600/20 dark:bg-green-400/10 dark:text-green-400 dark:inset-ring-green-500/20">Refesh
                            Request Sent!</span>
                        }
                        @else {
                        @if (allowedToRefreshInstagramAccount(instagramBasics()!.updatedDate)) {
                        <button (click)="refreshInstagramAccount()" type="button"
                            class="inline-flex items-center gap-x-1.5 btn-shout btn-shout-xs btn-shout-primary">
                            Refresh Account
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="-mr-0.5 size-5">
                                <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                                <path d="M3 3v5h5" />
                                <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" />
                                <path d="M16 16h5v5" />
                            </svg>
                        </button>
                        } @else {
                        <span
                            class="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 inset-ring inset-ring-green-600/20 dark:bg-green-400/10 dark:text-green-400 dark:inset-ring-green-500/20">Up
                            to date</span>
                        }
                        }
                    </div>
                </div>
            </div>
        </div>

        <!-- Admin Row - END -->

        <!-- 1 Column Audience Row -->
        <!-- <div
            class="divide-y divide-gray-200 overflow-hidden rounded-lg bg-gradient-to-b from-white via-zinc-50 to-zinc-100 border border-gray-200">
            <div class="flex flex-row items-center justify-between flex-nowrap px-3 py-2">
                <div class="flex items-center flex-row gap-x-2">
                    <div class="shrink-0 size-8 rounded-full bg-gray-50 flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5">
                            <path d="M3 3v16a2 2 0 0 0 2 2h16" />
                            <path d="M7 16c.5-2 1.5-7 4-7 2 0 2 3 4 3 2.5 0 4.5-5 5-7" />
                        </svg>
                    </div>
                    <div class="">
                        <h3 class="text-sm font-semibold text-gray-900">Account Statistics</h3>
                    </div>
                </div>
                <div class="flex shrink-0 gap-x-2 text-transparent">
                    RHS
                </div>
            </div>
            <div class="px-3 py-3 grid grid-cols-3 gap-2">
                <div class="col-span-1 bg-white rounded-lg p-2 border border-gray-200">
                </div>
                <div class="col-span-1 bg-white rounded-lg p-2 border border-gray-200">
                </div>
                <div class="col-span-1 bg-white rounded-lg p-2 border border-gray-200">
                </div>
            </div>
        </div> -->
        <!-- 1 Column Audience Row END -->

        <!-- 1 Column Instagram Posts Row -->
        <div class="shrink-0 divide-y divide-gray-200 dark:divide-zinc-700 overflow-hidden card-container-pale">
            <div class="flex flex-row items-center justify-between flex-nowrap px-3 py-2">
                <div class="flex items-center flex-row gap-x-2">
                    <div
                        class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5">
                            <path d="M2 7v10" />
                            <path d="M6 5v14" />
                            <rect width="12" height="18" x="10" y="3" rx="2" />
                        </svg>
                    </div>
                    <div class="">
                        <h3 class="text-sm font-semibold text-primary">Instagram Posts</h3>
                    </div>
                </div>
            </div>
            <div class="px-3 py-3 w-full shrink-0 overflow-hidden">

                @if (instagramBasics()?.apifyContentScrapingLimited) {
                <div class="flex flex-col gap-4 p-4 w-full items-center justify-center">
                    <div class="text-center">
                        <img class="size-10 mx-auto" src="../../../../../assets/social-icon/instagram-logo.png"
                            alt="Instagram">
                        <h3 class="mt-2 text-sm font-semibold text-primary">Whoops!</h3>
                        <p class="mt-1 text-sm text-secondary">The content on this account has been limited due to
                            Instagram's rules.
                        </p>
                    </div>
                </div>
                } @else {
                @if (instagramPosts() && instagramPosts()!.length > 0) {
                <div class="flex flex-col gap-4">
                    <ul role="list" class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-2 gap-y-4">
                        @for (post of instagramPosts() || []; track post.id) {
                        <li
                            class="relative w-full min-w-0 bg-white dark:bg-zinc-900 rounded-lg p-2 border border-gray-200 dark:border-zinc-800 flex flex-col self-start">
                            <div class="relative overflow-hidden rounded-lg">
                                <atom-media-viewer-simpler
                                    class="w-full group overflow-hidden rounded-lg bg-gray-100 dark:bg-zinc-800 focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-primary dark:focus-within:outline-primary"
                                    [src]="getCoverImage(post)"
                                    [inputClass]="'w-full pointer-events-none aspect-9/16 object-cover group-hover:opacity-75 rounded-t-lg'"
                                    [post]="post" w="full"></atom-media-viewer-simpler>
                                @if (canPlaySuperSocialInstagram(post)) {
                                <button type="button"
                                    class="absolute inset-0 flex items-center justify-center rounded-lg bg-black/20 hover:bg-black/40 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                                    (click)="openSuperSocialInstagram(post)" aria-label="Play Instagram video">
                                    <span
                                        class="flex size-12 items-center justify-center rounded-full bg-white/90 text-accent shadow-md"
                                        aria-hidden="true">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                            class="size-6">
                                            <path fill-rule="evenodd"
                                                d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z"
                                                clip-rule="evenodd" />
                                        </svg>
                                    </span>
                                </button>
                                }
                            </div>
                            <p class="text-xs text-secondary line-clamp-2 h-[2lh] mt-2">{{ post.description }}</p>
                        </li>
                        }
                    </ul>
                </div>
                } @else if (instagramPosts() && instagramPosts()?.length === 0) {
                <div class="flex flex-col gap-4 p-4 w-full items-center justify-center">
                    <div class="text-center">
                        <img class="size-10 mx-auto" src="../../../../../assets/social-icon/instagram-logo.png"
                            alt="Instagram">
                        <h3 class="mt-2 text-sm font-semibold text-primary">No Instagram posts found</h3>
                        <p class="mt-1 text-sm text-secondary">Instagram posts will appear here once they are available.
                        </p>
                    </div>
                </div>
                } @else {
                <div class="flex flex-col gap-4 p-4 w-full items-center justify-center">
                    <div class="text-center">
                        <svg aria-hidden="true"
                            class="mx-auto w-12 h-12 text-gray-200 animate-spin dark:text-gray-300 fill-primary"
                            viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="currentColor" />
                            <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentFill" />
                        </svg>
                        <h3 class="mt-2 text-sm font-semibold text-gray-900 dark:text-white">Loading...</h3>
                        <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Fetching Instagram posts
                        </p>
                    </div>
                </div>
                }
                }
            </div>
        </div>
        <!-- 1 Column Instagram Posts Row END -->


    </div>


    } @else if (creator && utlra_instagram_account()) {
        <div class="flex-1 w-full flex flex-col gap-y-2 overflow-y-auto scrollbar-hide p-1 min-h-0">
            <div class="w-full grid grid-cols-3 gap-x-2">
                <div
                    class="col-span-1 p-2 overflow-hidden rounded-lg bg-white shadow-sm dark:bg-gray-800/50 dark:shadow-none dark:outline dark:-outline-offset-1 dark:outline-white/10 flex flex-row gap-x-2 ">
                    <div class="shrink-0">
                        <div
                            class="relative shrink-0 size-16 rounded-full outline-1 -outline-offset-1 outline-black/5 dark:outline-white/10">
                            <atom-ldg-img inputClass="object-cover" w="full" h="full" radius="full"
                                [src]="imageService.getImageSource(utlra_instagram_account()!.avatarUrl, 'gallery')"></atom-ldg-img>
                        </div>
                    </div>
                    <div class="flex-1">
                        @if (creator.instaHandle) {
                        @if (instagramHandleRevealed()) {
                        <h3 class="text-sm font-semibold text-primary">&#64;{{ creator.instaHandle.replace('@',
                            '')
                            }}</h3>
                        } @else {
                        <h3 class="text-sm font-semibold font-mono tabular-nums tracking-wide text-secondary select-none"
                            aria-label="Instagram handle is hidden until your subscription is active.">
                            &#64;••••••••</h3>
                        <p class="text-xs text-secondary mt-0.5">Available with an active subscription.</p>
                        }
                        } @else {
                        <h3 class="text-sm font-semibold text-primary">Account Details</h3>
                        }
                        <p class="mt-1 text-gray-500 dark:text-gray-400">{{ utlra_instagram_account()!.bio }}</p>
                    </div>
                </div>

                <div
                    class="col-span-2 overflow-hidden rounded-lg bg-white shadow-sm dark:bg-gray-800/50 dark:shadow-none dark:outline dark:-outline-offset-1 dark:outline-white/10 flex flex-row gap-x-2 ">
                    <div class="bg-white dark:bg-gray-900 w-full">
                        <div
                            class="grid grid-cols-1 gap-px bg-gray-900/5 sm:grid-cols-2 lg:grid-cols-3 dark:bg-white/10">
                            <div class="bg-white px-2 py-2 sm:px-2 lg:px-2 dark:bg-gray-900">
                                <p class="text-sm/6 font-medium text-gray-500 dark:text-gray-400">Followers
                                </p>
                                <p class="flex items-baseline gap-x-2">
                                    <span class="text-xl font-semibold tracking-tight text-gray-900 dark:text-white">{{
                                        formatService.convertIntToString(utlra_instagram_account()!.followerCount)
                                        }}</span>
                                </p>
                            </div>
                            <div class="bg-white px-2 py-2 sm:px-2 lg:px-2 dark:bg-gray-900">
                                <p class="text-sm/6 font-medium text-gray-500 dark:text-gray-400">Posts</p>
                                <p class="flex items-baseline gap-x-2">
                                    <span class="text-xl font-semibold tracking-tight text-gray-900 dark:text-white">{{
                                        formatService.convertIntToString(utlra_instagram_account()!.postCount) }}</span>
                                </p>
                            </div>
                            <div class="bg-white px-2 py-2 sm:px-2 lg:px-2 dark:bg-gray-900">
                                <p class="text-sm/6 font-medium text-gray-500 dark:text-gray-400">Likes
                                </p>
                                <p class="flex items-baseline gap-x-2">
                                    <span class="text-xl font-semibold tracking-tight text-gray-900 dark:text-white">{{
                                        formatService.convertIntToString(utlra_instagram_account()!.likesCount) }}</span>
                                </p>
                            </div>
                            <div class="bg-white px-2 py-2 sm:px-2 lg:px-2 dark:bg-gray-900">
                                <p class="text-sm/6 font-medium text-gray-500 dark:text-gray-400">Avg. Views</p>
                                <p class="flex items-baseline gap-x-2">
                                    <span
                                        class="text-xl font-semibold tracking-tight text-gray-900 dark:text-white">-</span>
                                </p>
                            </div>
                            <div class="bg-white px-2 py-2 sm:px-2 lg:px-2 dark:bg-gray-900">
                                <p class="text-sm/6 font-medium text-gray-500 dark:text-gray-400">Avg. Likes</p>
                                <p class="flex items-baseline gap-x-2">
                                    @if (utlra_instagram_account()!.likesCount && utlra_instagram_account()!.postCount) {
                                    <span class="text-xl font-semibold tracking-tight text-gray-900 dark:text-white">{{
                                        formatService.convertIntToString(utlra_instagram_account()!.likesCount /
                                        utlra_instagram_account()!.postCount) }}</span>
                                    } @else {
                                    <span
                                        class="text-xl font-semibold tracking-tight text-gray-900 dark:text-white">-</span>
                                    }
                                </p>
                            </div>
                            <div class="bg-white px-2 py-2 sm:px-2 lg:px-2 dark:bg-gray-900">
                                <p class="text-sm/6 font-medium text-gray-500 dark:text-gray-400">Avg. Engagement</p>
                                <p class="flex items-baseline gap-x-2">
                                    <span
                                        class="text-xl font-semibold tracking-tight text-gray-900 dark:text-white">-</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            @if (utlra_instagram_posts() && utlra_instagram_posts()!.length > 0) {
            <div class="flex flex-col gap-4">
                <ul role="list" class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-2 gap-y-4">
                    @for (post of utlra_instagram_posts(); track post.id) {
                    <li
                        class="relative w-full min-w-0 bg-white dark:bg-zinc-900 rounded-lg p-2 border border-gray-200 dark:border-zinc-800 flex flex-col self-start">
                        @if (post.assetMediaUrl) {
                        <mgc-portfolio-inline-video [video]="assembledVideoObject(post)"></mgc-portfolio-inline-video>
                        } @else {
                        <div class="relative overflow-hidden rounded-lg">
                            @if (post.thumbnailUrl) {
                            <mgc-portfolio-inline-video [video]="assembledVideoObject(post)"></mgc-portfolio-inline-video>
                            } @else {
                            <img src="/assets/images/placeholder-video.png" alt="Instagram post unavailable"
                                class="aspect-9/16 w-full h-full object-cover rounded-lg" />
                            }
                            @if (canPlayUltraInstagram(post)) {
                            <button type="button"
                                class="absolute inset-0 flex items-center justify-center rounded-lg bg-black/20 hover:bg-black/40 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                                (click)="openUltraInstagram(post)" aria-label="Play Instagram video">
                                <span
                                    class="flex size-12 items-center justify-center rounded-full bg-white/90 text-accent shadow-md"
                                    aria-hidden="true">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                        class="size-6">
                                        <path fill-rule="evenodd"
                                            d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z"
                                            clip-rule="evenodd" />
                                    </svg>
                                </span>
                            </button>
                            }
                        </div>
                        }

                        @if (post.viewCount != null || post.likeCount != null) {
                        <p class="text-xs text-secondary mt-2">
                            @if (post.viewCount != null) {
                            {{ formatService.convertIntToString(post.viewCount) }} views
                            }
                            @if (post.likeCount != null) {
                            · {{ formatService.convertIntToString(post.likeCount) }} likes
                            }
                        </p>
                        }

                        <p class="text-xs text-secondary line-clamp-2 h-[2lh] mt-1">{{ post.caption }}</p>
                    </li>
                    }
                </ul>
            </div>
            } @else if (utlra_instagram_posts() && utlra_instagram_posts()!.length === 0) {
            <div class="flex flex-col gap-4 p-4 w-full items-center justify-center">
                <div class="text-center">
                    <img class="size-10 mx-auto" src="../../../../../assets/social-icon/instagram-logo.png"
                        alt="Instagram">
                    <h3 class="mt-2 text-sm font-semibold text-primary">No Instagram posts found</h3>
                    <p class="mt-1 text-sm text-secondary">Instagram posts will appear here once they are
                        available.
                    </p>
                </div>
            </div>
            } @else {
            <div class="flex flex-col gap-4 p-4 w-full items-center justify-center">
                <atom-loading-inline [title]="'Instagram Posts'" [message]="'Loading... '"></atom-loading-inline>
            </div>
            }
        </div>
    }

    @else if (ultra_social_instagram) {
    <div class="flex-1 w-full flex flex-col p-2 min-h-0 items-center justify-center">
        <atom-loading-inline [title]="'Instagram'" [message]="'Loading... '"></atom-loading-inline>
    </div>
    } @else if (creator.instaHandle) {
    <div class="flex-1 w-full flex flex-col items-center justify-center gap-4 p-6 min-h-0">
        <div class="w-full max-w-md rounded-xl border border-border bg-card p-5">
            <div class="flex items-center gap-3">
                <img class="size-10 shrink-0 object-contain" src="../../../../../assets/social-icon/instagram-logo.png"
                    alt="">
                <div class="min-w-0 flex-1">
                    <p class="m-0 truncate text-sm font-bold text-primary">
                        &#64;{{ creator.instaHandle.replace('@', '') }}
                    </p>
                    <p class="m-0 text-xs text-secondary">Instagram</p>
                </div>
                <p class="m-0 shrink-0 text-lg font-extrabold text-primary">
                    {{ creator.instaFollowers ? formatService.convertIntToString(creator.instaFollowers) : '—' }}
                </p>
            </div>
            <p class="m-0 mt-4 text-sm text-secondary">
                This handle is on the creator profile, but Instagram isn’t linked to Super Social or Ultra yet — posts
                and analytics will show here once that connection is live.
            </p>
            <a class="btn-shout btn-shout-sm btn-shout-secondary mt-4 inline-flex"
                [attr.href]="'https://www.instagram.com/' + creator.instaHandle.replace('@', '')" target="_blank"
                rel="noopener noreferrer">
                Open Instagram
            </a>
        </div>
    </div>
    } @else if (creator && creator.ssCreator && !creator.ssCreator.instagramAccountId) {
    <div class="flex-1 w-full flex flex-col p-2 min-h-0 items-center justify-center">
        <div class="text-center">
            <img class="size-10 mx-auto" src="../../../../../assets/social-icon/instagram-logo.png" alt="Instagram">
            <h3 class="mt-2 text-sm font-semibold text-primary">Instagram account not connected</h3>
            <p class="mt-1 text-sm text-secondary">When the creator connects their Instagram account, their account
                details will appear here.
            </p>
        </div>
    </div>
    } @else if (creator && !creator.ssCreator) {
    <div class="flex-1 w-full flex flex-col p-2 min-h-0 items-center justify-center">
        <div class="text-center">
            <img class="size-10 mx-auto" src="../../../../../assets/social-icon/instagram-logo.png" alt="Instagram">
            <h3 class="mt-2 text-sm font-semibold text-primary">No Instagram account connected</h3>
            <p class="mt-1 text-sm text-secondary">When the creator connects their Instagram account, their account
                details will appear here.
            </p>
        </div>
    </div>
    } @else {
    <div class="flex-1 w-full flex flex-col p-2 min-h-0 items-center justify-center">
        <div class="text-center">
            <img class="size-10 mx-auto" src="../../../../../assets/social-icon/instagram-logo.png" alt="Instagram">
            <h3 class="mt-2 text-sm font-semibold text-primary">Something else...</h3>
            <p class="mt-1 text-sm text-secondary">When the creator connects their Instagram account, their account
                details will appear here.
            </p>
        </div>
    </div>
    }
</div>

<app-dialog [open]="instagramEmbedOpen()" (closed)="closeInstagramEmbed()">
    <div dialog-header>
        <h2 class="text-lg font-semibold text-primary">Instagram post</h2>
    </div>
    <div dialog-body class="flex flex-col items-center gap-3">
        @if (instagramNativeUrl()) {
        <video [src]="instagramNativeUrl()" controls autoplay
            class="aspect-9/16 w-full max-w-sm rounded-lg bg-black"></video>
        } @else if (instagramEmbedSrc()) {
        <iframe [src]="instagramEmbedSrc()" title="Instagram post"
            class="aspect-9/16 w-full max-w-sm rounded-lg bg-black"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            allowfullscreen></iframe>
        }
        @if (instagramWatchUrl()) {
        <a class="text-sm font-medium text-accent hover:underline" [href]="instagramWatchUrl()"
            target="_blank" rel="noopener noreferrer">Open on Instagram</a>
        }
    </div>
</app-dialog>
</ng-container>